"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenModalAction = void 0;
exports.buildEditModalActions = buildEditModalActions;
var React = _interopRequireWildcard(require("react"));
var _useModal = require("./useModal");
var _modal = require("./modal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OpenModalAction = ({
  modal,
  actionComponent
}) => {
  const {
    showModal
  } = (0, _useModal.useModal)();
  const callback = () => {
    showModal(modal);
  };
  return /*#__PURE__*/React.cloneElement(actionComponent, {
    onClick: callback
  });
};
exports.OpenModalAction = OpenModalAction;
function buildEditModalActions(handleSubmit, hideModal, isDisabled) {
  return [{
    type: _modal.ActionType.Primary,
    label: 'Save',
    inputType: 'submit',
    disabled: isDisabled,
    onClick: handleSubmit,
    qaDataAttribute: 'submit-modal-button'
  }, {
    type: _modal.ActionType.Secondary,
    label: 'Cancel',
    inputType: 'button',
    disabled: isDisabled,
    onClick: hideModal,
    qaDataAttribute: 'cancel-modal-button'
  }];
}